/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto
 */
export interface WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto
     */
    memberUniqueId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto
     */
    memberId?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto
     */
    settledAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto
     */
    disbursedAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto
     */
    orginalAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto
     */
    json?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto
     */
    bankAccountNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto
     */
    reference?: string | null;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto interface.
 */
export function instanceOfWebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDtoFromJSON(json: any): WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto {
    return WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'memberUniqueId': !exists(json, 'memberUniqueId') ? undefined : json['memberUniqueId'],
        'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'settledAt': !exists(json, 'settledAt') ? undefined : (json['settledAt'] === null ? null : new Date(json['settledAt'])),
        'disbursedAt': !exists(json, 'disbursedAt') ? undefined : (json['disbursedAt'] === null ? null : new Date(json['disbursedAt'])),
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'orginalAmount': !exists(json, 'orginalAmount') ? undefined : json['orginalAmount'],
        'json': !exists(json, 'json') ? undefined : json['json'],
        'bankAccountNumber': !exists(json, 'bankAccountNumber') ? undefined : json['bankAccountNumber'],
        'reference': !exists(json, 'reference') ? undefined : json['reference'],
    };
}

export function WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDtoToJSON(value?: WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'memberUniqueId': value.memberUniqueId,
        'memberId': value.memberId,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'settledAt': value.settledAt === undefined ? undefined : (value.settledAt === null ? null : value.settledAt.toISOString()),
        'disbursedAt': value.disbursedAt === undefined ? undefined : (value.disbursedAt === null ? null : value.disbursedAt.toISOString()),
        'amount': value.amount,
        'orginalAmount': value.orginalAmount,
        'json': value.json,
        'bankAccountNumber': value.bankAccountNumber,
        'reference': value.reference,
    };
}

